export default __webpack_public_path__ + "static/media/logoText.d688fc73.svg";